type ResizeCallback = () => void

class ResizeManager {
  // eslint-disable-next-line no-use-before-define
  private static instance: ResizeManager
  private callbacks = new Set<ResizeCallback>()
  private listenerAttached = false

  static getInstance() {
    if (!ResizeManager.instance) {
      ResizeManager.instance = new ResizeManager()
    }

    return ResizeManager.instance
  }

  register(callback: ResizeCallback) {
    this.callbacks.add(callback)
    this.ensureListener()
  }

  unregister(callback: ResizeCallback) {
    this.callbacks.delete(callback)

    if (this.callbacks.size === 0) {
      this.removeListener()
    }
  }

  private handleResize = () => {
    for (const cb of this.callbacks) {
      cb()
    }
  }

  private ensureListener() {
    if (!this.listenerAttached) {
      window.addEventListener('resize', this.handleResize)
      this.listenerAttached = true
    }
  }

  private removeListener() {
    if (this.listenerAttached) {
      window.removeEventListener('resize', this.handleResize)
      this.listenerAttached = false
    }
  }
}

// Use a global key to ensure only one instance of the resize manager is created
// Had to do this because even though this is a singleton, it was being created multiple times
const globalKey = '__nutra_resize_manager__'
const globalAny = globalThis as any

if (!globalAny[globalKey]) {
  globalAny[globalKey] = new ResizeManager()
}

export const resizeManager = globalAny[globalKey] as ResizeManager
